import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const SettingsLayout = lazy(() => import('@/pages/settings/layout'));
const IntegrationsSettingsPage = lazy(() => import('@/pages/settings/integrations'));

/** System settings pages: `/settings/integrations` (permission in `@/config/auth/routeAccess`). */
export const settingsRoutes: RouteConfig = {
  path: '/settings',
  layout: DashboardLayout,
  children: [{ path: '/integrations', layout: SettingsLayout, element: IntegrationsSettingsPage }],
};
